import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import uuid from 'react-uuid';
import NumberFormat from 'react-number-format';
import { InputTemplate } from 'modules/common/components/inputComponents';
import { reactSelectCustomStyleCms } from 'helper';

const ViewUpdateBusinessOperations = ({
  formData,
  setFormData,
  onChange,
  validateForm,
  businessNecessaryField,
  onChangeDetails,
}) => {
  const filteredBusinessNecessaryField = businessNecessaryField.filter(
    (item) => !item.quantity_matrix
  );
  const filteredQuantityMatrix = businessNecessaryField.filter(
    item => _.isArray(item.quantity_matrix) && item.quantity_matrix.length > 0
  );
  const quantityMatrixValue = _.get(formData, 'details.quantity_matrix', {});

  return (
    <div className="row m-3">
      <div className="col-6 form-group">
        <label htmlFor="area" className="form-label mb-0">
          Total Floor Area (sq.m):{' '}
          {validateForm.renderMessage('floor_area')}
        </label>
        <NumberFormat
          name="floor_area"
          id="floor_area"
          allowLeadingZeros
          className="form-control"
          onValueChange={(values) => {
            const { value } = values;
            const floorArea = Number(value || 0);
            const areaValue = Number(_.get(formData, 'area') || 0);
            setFormData({
              ...formData,
              floor_area: value,
              area:
                floorArea > 0 && areaValue > floorArea
                  ? value
                  : _.get(formData, 'area', ''),
            });
          }}
          displayType="input"
          thousandSeparator
          isNumericString
          prefix=""
          value={_.get(formData, `floor_area`, 0)}
          placeholder="_"
        />
      </div>
      <div className="col-6 form-group">
        <label htmlFor="area" className="form-label mb-0">
          Business Area (sq.m):{' '}
          {validateForm.renderMessage('area')}
        </label>
        <NumberFormat
          name="area"
          id="area"
          allowLeadingZeros
          className="form-control"
          onValueChange={(values) => {
            const { value } = values;
            const floorArea = Number(_.get(formData, 'floor_area') || 0);
            const areaValue = Number(value || 0);
            const nextArea =
              floorArea > 0 && areaValue > floorArea ? _.get(formData, 'floor_area') : value;
            setFormData({
              ...formData,
              area: nextArea,
            });
          }}
          displayType="input"
          thousandSeparator
          isNumericString
          prefix=""
          value={_.get(formData, `area`, 0)}
          placeholder="_"
        />
      </div>

      <div className="col-6 form-group">
        <label htmlFor="employees_residing" className="form-label mb-0">
          Number of Employees residing within Area:{' '}
          {validateForm.renderMessage('no_of_employees_residing_manila')}
        </label>
        <NumberFormat
          name="no_of_employees_residing_manila"
          id="no_of_employees_residing_manila"
          allowLeadingZeros
          className="form-control"
          onValueChange={(values) => {
            const { floatValue } = values;
            const cb = {
              target: {
                name: 'no_of_employees_residing_manila',
                value: floatValue,
              },
            };
            onChange(cb);
          }}
          displayType="input"
          thousandSeparator
          isNumericString
          prefix=""
          value={_.get(formData, `no_of_employees_residing_manila`, 0)}
          placeholder="_"
        />
      </div>

      <div className="col-6 form-group">
        <label htmlFor="male_employees" className="form-label mb-0">
          Total Number of Male Employees:{' '}
          {validateForm.renderMessage('no_of_male_employees')}
        </label>
        <NumberFormat
          name="no_of_male_employees"
          id="no_of_male_employees"
          allowLeadingZeros
          className="form-control"
          onValueChange={(values) => {
            const { floatValue } = values;
            const cb = {
              target: {
                name: 'no_of_male_employees',
                value: floatValue,
              },
            };
            onChange(cb);
          }}
          displayType="input"
          thousandSeparator
          isNumericString
          prefix=""
          value={_.get(formData, `no_of_male_employees`, 0)}
          placeholder="_"
        />
      </div>

      <div className="col-6 form-group">
        <label htmlFor="female_employees" className="form-label mb-0">
          Total Number of Female Employees:{' '}
          {validateForm.renderMessage('no_of_female_employees')}
        </label>
        <NumberFormat
          name="no_of_female_employees"
          id="no_of_female_employees"
          allowLeadingZeros
          className="form-control"
          onValueChange={(values) => {
            const { floatValue } = values;
            const cb = {
              target: {
                name: 'no_of_female_employees',
                value: floatValue,
              },
            };
            onChange(cb);
          }}
          displayType="input"
          thousandSeparator
          isNumericString
          prefix=""
          value={_.get(formData, `no_of_female_employees`, 0)}
          placeholder="_"
        />
      </div>

      <div className="col-6 form-group">
        <label htmlFor="van_count" className="form-label mb-0">
          Number of Van Delivery Vehicle: (0 if not applicable):{' '}
          {validateForm.renderMessage('no_of_van')}
        </label>
        <NumberFormat
          name="no_of_van"
          id="no_of_van"
          allowLeadingZeros
          className="form-control"
          onValueChange={(values) => {
            const { floatValue } = values;
            const cb = {
              target: {
                name: 'no_of_van',
                value: floatValue,
              },
            };
            onChange(cb);
          }}
          displayType="input"
          thousandSeparator
          isNumericString
          prefix=""
          value={_.get(formData, `no_of_van`, 0)}
          placeholder="_"
        />
      </div>

      <div className="col-6 form-group">
        <label htmlFor="truck_count" className="form-label mb-0">
          Number of Truck Delivery Vehicle: (0 if not applicable):{' '}
          {validateForm.renderMessage('no_of_truck')}
        </label>
        <NumberFormat
          name="no_of_truck"
          id="no_of_truck"
          allowLeadingZeros
          className="form-control"
          onValueChange={(values) => {
            const { floatValue } = values;
            const cb = {
              target: {
                name: 'no_of_truck',
                value: floatValue,
              },
            };
            onChange(cb);
          }}
          displayType="input"
          thousandSeparator
          isNumericString
          prefix=""
          value={_.get(formData, `no_of_truck`, 0)}
          placeholder="_"
        />
      </div>

      <div className="col-6 form-group">
        <label htmlFor="motorcycle_count" className="form-label mb-0">
          Number of Motorcycle Delivery Vehicle: (0 if not applicable):{' '}
          {validateForm.renderMessage('no_of_motorcycle')}
        </label>
        <NumberFormat
          name="no_of_motorcycle"
          id="no_of_motorcycle"
          allowLeadingZeros
          className="form-control"
          onValueChange={(values) => {
            const { floatValue } = values;
            const cb = {
              target: {
                name: 'no_of_motorcycle',
                value: floatValue,
              },
            };
            onChange(cb);
          }}
          displayType="input"
          thousandSeparator
          isNumericString
          prefix=""
          value={_.get(formData, `no_of_motorcycle`, 0)}
          placeholder="_"
        />
      </div>

      {!_.isEmpty(filteredBusinessNecessaryField) &&
        filteredBusinessNecessaryField.map((field) => {
          const multiplier = _.get(field, 'multiplier', '');
          const optionField = _.get(field, 'options', []);
          const options = optionField.map((option) => ({
            label: _.get(option, 'multiplier', '')
              .replace(/_/g, ' ')
              .replace(/^(.)|\s+(.)/g, (x) => x.toUpperCase()),
            value: _.get(option, 'multiplier', ''),
          }));

          if (!_.isEmpty(optionField)) {
            return (
              <InputTemplate
                key={uuid()}
                isSelect
                title={multiplier.replace(/_/g, ' ')}
                labelClassName="text-capitalize"
                containerClassName="col-6 d-flex flex-column"
                styles={reactSelectCustomStyleCms()}
                placeholder="Select"
                options={options}
                value={options.find(
                  (option) =>
                    option.value === _.get(formData, `details.${multiplier}`)
                )}
                onChange={({ value }) => onChangeDetails('multiplier', multiplier, value)}
                components={{ IndicatorSeparator: () => null }}
              />
            );
          }

          return (
            <InputTemplate
              key={uuid()}
              title={multiplier.replace(/_/g, ' ')}
              htmlFor={multiplier}
              labelClassName="text-capitalize"
              containerClassName="col-6 d-flex flex-column"
              placeholder="_"
              className="form-control"
              style={{
                outline: 'none',
                borderRadius: '4px',
                border: '1px solid #d9d9d9',
                minHeight: 40,
              }}
              withCustomInputComponent={() => (
                <NumberFormat
                  name={multiplier}
                  id={multiplier}
                  allowLeadingZeros
                  className="form-control"
                  onValueChange={(values) => {
                    const { floatValue } = values;
                    onChangeDetails('multiplier', multiplier, floatValue);
                  }}
                  displayType="input"
                  thousandSeparator
                  isNumericString
                  prefix=""
                  value={_.get(formData, `details.${multiplier}`)}
                  placeholder="_"
                />
              )}
            />
          );
        })}
      {!_.isEmpty(filteredQuantityMatrix) ? (
        filteredQuantityMatrix.map((item) => {
          const multiplier = _.get(item, 'multiplier', '');

          return (
            <React.Fragment>
              <div className='form-group col-12 mb-0'>
                <label className='form-label mb-0 text-capitalize'>
                  {multiplier}
                </label>
              </div>
              <div className="w-100 border rounded-lg mx-3 mb-2">
                <table className="table table-borderless table-sm table-striped table-hover mb-0">
                  <thead>
                    <tr className="form-group">
                      <td className="col-4 form-label text-center border-right">Unit</td>
                      <td className="col-4 form-label text-center border-right">Capacity</td>
                      <td className="col-4 form-label text-center">Number of Units</td>
                    </tr>
                  </thead>
                  <tbody>
                    {item.quantity_matrix.map((quantityMatrixItem) => {
                      const quantityMatrixMultiplier = _.get(quantityMatrixItem, 'multiplier');

                      return (
                        // eslint-disable-next-line react/no-array-index-key
                        <tr
                          key={quantityMatrixMultiplier}
                          className="border-top form-group"
                        >
                          <td className="col-4 text-left form-label border-right">
                            {_.get(quantityMatrixItem, 'unit')}
                          </td>
                          <td className="col-4 text-left form-label border-right">
                            {_.get(quantityMatrixItem, 'capacity')}
                          </td>
                          <td className="col-4 text-left form-label">
                            <NumberFormat
                              name={quantityMatrixMultiplier}
                              id={quantityMatrixMultiplier}
                              allowLeadingZeros
                              className="form-control"
                              onValueChange={(values) => {
                                const { floatValue } = values;
                                onChangeDetails('quantity_matrix', quantityMatrixMultiplier, floatValue);
                              }}
                              displayType="input"
                              thousandSeparator
                              isNumericString
                              prefix=""
                              value={quantityMatrixValue[quantityMatrixMultiplier]}
                              placeholder="_"
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </React.Fragment>
          )
        })
        
      ) : (
        ''
      )}
    </div>
  );
};

ViewUpdateBusinessOperations.propTypes = {
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  onChange: PropTypes.instanceOf(Function).isRequired,
  validateForm: PropTypes.instanceOf(Object).isRequired,
  businessNecessaryField: PropTypes.instanceOf(Array).isRequired,
  onChangeDetails: PropTypes.instanceOf(Function).isRequired,
};

export default ViewUpdateBusinessOperations;
